// extracted by mini-css-extract-plugin
var _1 = "TableEmbed-module__container--dQV98";
var _2 = "37px";
var _3 = "TableEmbed-module__rearrangingState--KnLJP";
var _4 = "TableEmbed-module__scrollContainer--F5ceX";
export { _1 as "container", _2 as "controlSize", _3 as "rearrangingState", _4 as "scrollContainer" }
